export const DOC_FLOW_TABLE_ROW_ACTIONS_CONFIG = {
  getOnClickProps: item => item,
}
